// extracted by mini-css-extract-plugin
export default {"container":"Fj-z","blurb":"Gj-z","links":"Hj-z"};